import EducationHead from '@/components/EducationHead'
import HaveQuestions from '@/components/HaveQuestions'
import { usePage } from '@/hooks'
import { bagWithScheme } from '@/images'
import React, { useState } from 'react'
import Contests from './components/Contests'
import Institutions from './components/Institutions'
import VideoSlider from './components/VideoSlider'

const BestInProfession = (): React.ReactElement => {
  const [playVideo, setPlayVideo] = useState('')

  const page = usePage()

  const { object } = page?.init_state
  const { config } = page?.init_state?.global

  return (
    <>
      <EducationHead
        title={object.title}
        backLink={config.education}
        backLinkTitle='Обучение'
        image={bagWithScheme}
        content={object.detail}
      />

      <VideoSlider playVideo={playVideo} setPlayVideo={setPlayVideo} />

      <Contests playVideo={playVideo} setPlayVideo={setPlayVideo} pageTitle={object.title} />

      <Institutions />

      <HaveQuestions />

    </>
  )
}
export default BestInProfession
